import React, { useState, useEffect } from "react";
import { Text, StyleSheet, View, Platform } from "react-native";

export default function AssociatedElements({
  element,
  controller,
  //mainSetColor = AppTheme.DEFAULT_COLOR,
  showAssociations = "all",
}) {
  const [template, setTemplate] = useState([]);

  useEffect(() => {
    setTemplate(groupElementsByType());
  }, [element]);

  const groupElementsByType = () => {
    const elementsById = {};
    (controller.state.elements || []).forEach((a) => {
      elementsById[a.id] = a;
    });

    const allRelatedElements = (element.parents || []).concat(element.children);

    let elementsByType = { core: [], major: [], minor: [] };
    allRelatedElements.forEach((elementId) => {
      const el = elementsById[elementId];
      if (el) {
        if (el?.is_core == 1) {
          elementsByType.core.push(el);
        } else if (el?.is_major == 1) {
          elementsByType.major.push(el);
        } else {
          elementsByType.minor.push(el);
        }
      }
    });

    const { core, major, minor } = elementsByType;
    let content = [];
    const uniqueElements =
      showAssociations == "minor"
        ? new Set([...minor])
        : new Set([...core, ...major, ...minor]);

    let prevType = "major"; //2021.05 - no | between core and major
    [...uniqueElements].forEach((el, index) => {
      if (el.is_active) {
        let elementType =
          el.is_core == 1 || el.is_major == 1 ? "major" : "minor";

        if (index > 0 && prevType != elementType) {
          content.push(<Text style={styles.separator}>|</Text>);
        } else if (index > 0) {
          content.push(<View style={styles.dotStyle} />);
        }
        content.push(
          <Text style={styles.elementName} numberOfLines={1}>
            {el.name}
          </Text>,
        );
        prevType = elementType;
      }
    });

    return content;
  };

  const hasMore = template.join("").length > 100;

  return showAssociations == "none" ? null : (
    <View style={styles.container}>
      <View style={styles.associatedText}>
        {template.map((t, index) => (
          <View key={index} style={styles.row}>
            {t}
          </View>
        ))}
      </View>
      {hasMore ? (
        <Text style={[styles.elementName, styles.hasMore]}>...</Text>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  hasMore: {
    fontWeight: "500",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: "#2D3142",
    marginLeft: 6,
  },
  associatedText: {
    //width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    maxWidth: 220,
    paddingRight: 6,
    overflow: "hidden",
  },
  row: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "nowrap",
    minWidth: 10,
    height: 20,
  },
  elementName: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.5,
    color: "#2D3142",
  },
  dotStyle: {
    width: 4,
    height: 4,
    maxWidth: 4,
    borderRadius: 4,
    backgroundColor: "#555",
  },
  separator: {
    width: 4,
    color: "#2D3142",
  },
});
